import { StylesConfig } from 'react-select'

// V8 (dashboard) styling for the course-filter selects: white control,
// v8-line border, 12px radius, 14px ink text, blue focus/hover accents.
// Passed via the *Styles props on CommonSubjectSelect /
// CommonExamLevelGroupSelect / CommonExamBoardsMultiSelect - the selects'
// own defaults stay untouched for other consumers.

const control = (baseStyles: any, props: any) => ({
  ...baseStyles,
  background: '#fff',
  border: '1px solid #DFE2EA',
  borderRadius: 12,
  boxShadow: 'none',
  minHeight: 44,
  fontSize: 14,
  color: '#080B14',
  cursor: props.isDisabled ? 'not-allowed' : 'pointer',
  ':hover': { borderColor: '#3157FF' },
  ...(props.isFocused ? { borderColor: '#3157FF' } : {}),
})

const menu = (baseStyles: any) => ({
  ...baseStyles,
  zIndex: 656,
  borderRadius: 12,
  border: '1px solid #DFE2EA',
  boxShadow: '0 8px 24px rgba(8, 11, 20, 0.08)',
  overflow: 'hidden',
})

const menuList = (baseStyles: any) => ({
  ...baseStyles,
  padding: 6,
})

const option = (baseStyles: any, props: any) => ({
  ...baseStyles,
  fontSize: 14,
  color: '#080B14',
  borderRadius: 8,
  cursor: props.isDisabled ? 'not-allowed' : 'pointer',
  background: props.isSelected
    ? '#E8EDFF'
    : props.isFocused
    ? '#F4F5F8'
    : 'transparent',
  ':active': { background: '#E8EDFF' },
})

const placeholder = (baseStyles: any) => ({
  ...baseStyles,
  color: '#5C6373',
  fontSize: 14,
  textWrap: 'nowrap',
  textOverflow: 'ellipsis',
})

const singleValue = (baseStyles: any) => ({
  ...baseStyles,
  color: '#080B14',
  fontSize: 14,
})

const multiValue = (baseStyles: any) => ({
  ...baseStyles,
  background: '#E8EDFF',
  borderRadius: 999,
  padding: '0 2px',
})

const multiValueLabel = (baseStyles: any) => ({
  ...baseStyles,
  color: '#3157FF',
  fontSize: 12,
  fontWeight: 600,
})

const multiValueRemove = (baseStyles: any) => ({
  ...baseStyles,
  color: '#3157FF',
  borderRadius: 999,
  ':hover': { background: '#3157FF', color: '#fff' },
})

const indicator = (baseStyles: any) => ({
  ...baseStyles,
  color: '#5C6373',
  ':hover': { color: '#3157FF' },
})

const loadingIndicator = (baseStyles: any) => ({
  ...baseStyles,
  marginRight: 0,
  color: '#3157FF',
})

export const v8SubjectSelectStyles: StylesConfig<any, any, any> = {
  control,
  menu,
  menuList,
  option,
  placeholder,
  singleValue,
  dropdownIndicator: indicator,
  clearIndicator: indicator,
  loadingIndicator,
}

export const v8ExamLevelSelectStyles: StylesConfig<any, any, any> = {
  ...v8SubjectSelectStyles,
}

// Board options render only a logo (next/image with fill), so each option
// needs an explicit size - without one the logo collapses to 0px tall and
// the menu looks empty.
const boardMenuList = (baseStyles: any) => ({
  ...baseStyles,
  padding: 6,
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: 4,
})

const boardOption = (baseStyles: any, props: any) => ({
  ...option(baseStyles, props),
  height: 44,
  padding: '8px 10px',
  opacity: props.isDisabled ? 0.6 : 1,
})

export const v8ExamBoardSelectStyles: StylesConfig<any, any, any> = {
  ...v8SubjectSelectStyles,
  menuList: boardMenuList,
  option: boardOption,
  multiValue,
  multiValueLabel,
  multiValueRemove,
}
